
export default {
  name: 'Header',

  data: function () {
    return {
      isHeaderFixed: false,
    };
  },
  computed: {
    vars: function () {
      return this.$store.state?.appState?.vars || {};
    },
    config: function () {
      return this.$store.state?.appState?.config || {};
    },

    workPhone: function () {
      return this.vars?.['Стационарный телефон'];
    },
    mobilePhone: function () {
      return this.vars?.['Мобильный телефон'];
    },

    address: function () {
      return this.vars?.['Полный адрес'];
    },

    socials: function () {
      const list = [];

      if (this.config?.whatsapp) {
        list.push({
          image: require('~/assets/img/svg/socials/whatsapp.svg'),
          link: this.config?.whatsapp,
        });
      }
      if (this.config?.telegram) {
        list.push({
          image: require('~/assets/img/svg/socials/telegram.svg'),
          link: this.config?.telegram,
        });
      }
      if (this.config?.vkontakte) {
        list.push({
          image: require('~/assets/img/svg/socials/vk.svg'),
          link: this.config?.vkontakte,
        });
      }

      return list;
    },

    cartInfo: function () {
      return this.$store.getters["cart/totalSum"];
    },

    cartProductCount: function () {
      return (this.$store?.state?.cart?.items || []).reduce((value, item) => value + item?.quantity || 0, 0);
    },

    contacts: function () {
      const vars = this.$store.state.appState?.vars || {};

      const list = [];
      if (vars['Интернет магазин (телефон)']) {
        list.push({
          text: 'Магазин',
          phone: this.$phoneFormat(vars['Интернет магазин (телефон)']),
          link: `tel:${vars['Интернет магазин (телефон)']}`,
          whatsapp: `https://api.whatsapp.com/send?phone=${vars['Интернет магазин (WhatsApp)']}`,
          telegramm: vars['Интернет магазин (телеграм)'],
        });
      }
      if (vars['Шиномонтаж и услуги (телефон)']) {
        list.push({
          text: 'Услуги',
          phone: this.$phoneFormat(vars['Шиномонтаж и услуги (телефон)']),
          link: `tel:${vars['Шиномонтаж и услуги (телефон)']}`,
          whatsapp: `https://api.whatsapp.com/send?phone=${vars['Шиномонтаж и услуги (WhatsApp)']}`,
          telegramm: vars['Шиномонтаж и услуги (телеграм)'],
        });
      }

      return list;
    },

    isVisibleFundUs: function () {
      return Boolean(this.$store.state.appState?.vars?.['ID CMS страницы Найти нас']);
    },
  },

  components: {
    Search: () => import('~/components/header/Search'),
    Catalog: () => import('~/components/header/Catalog'),
    Menu: () => import('~/components/header/Menu'),
    // YourCar: () => import('~/components/header/YourCar'),
    MobileContactData: () => import('~/components/header/MobileContactData'),
  },

  mounted: function () {
    window.addEventListener('scroll', this.scrollEvent);
  },
  unmounted: function () {
    window.removeEventListener('scroll', this.scrollEvent);
  },

  methods: {
    scrollEvent: function () {
      const scrollTop = window.pageYOffset;
      this.isHeaderFixed = Boolean(scrollTop > 147);
    },

    openSearch: function () {
      this.$store.commit('search/setOpen', true);
    },
    openMobileMenu: function () {
      this.$store.commit('mobile-menu/openMenu');
    },

    openFundUs: function () {
      const pageId = this.$store.state.appState?.vars?.['ID CMS страницы Найти нас'];
      this.$store.commit('pop-up-cms-page/open', pageId);
    },
    openFormFeedback: function () {
      this.$store.commit('pop-up-back-call/open');
    },
  },
};
